import axios from "axios";

// Create axios instance with base configuration
export const api = axios.create({
  baseURL: "https://dvtime-1c6x.onrender.com",
  timeout: 300000, // 5 minutes for file uploads
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to attach bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - could trigger logout here
      console.error("Unauthorized - token may be invalid");
    }
    return Promise.reject(error);
  }
);

export default api;
